<template>
  <div>
    <van-nav-bar
      class="backBox"
      title="系统消息"
      right-text=""
      left-arrow
      @click-left="onClickLeft"
    />

    <div class="content_box">
      <div class="message_box">
        <div class="create-time">
          <div class="msgBeforeTit">上报时间：</div>
          <div class="msgAfterText">{{ createTime }}</div>
        </div>

        <div class="content-wrap">
          <div class="content-title msgBeforeTit">消息内容：</div>
          <span class="msgAfterText">{{ content }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import * as api from '../../api/api'
import * as common from '../../api/common'

import * as utils from '../../api/utils'
export default {
  data () {
    return {
      createTime: '',
      content: '',
      detailObj: {}

    }
  },
  mounted () {
    this.detailObj = this.$route.query
    this.queryList()
  },
  computed: {

  },
  methods: {
    queryList () {
      const para = {
        id: this.detailObj.id
      }
      api
        .axiosRequest(api.urlList.querySystemMsg, para)
        .then((res) => {
          if (res.code === common.resCode.OK) {
            this.createTime = utils.formatZHYMDHM(utils.formatDate(res.create_time))

            this.content = res.content
            this.readMag()
          } else {
            utils.judgeBackMsg(res)
          }
        })
        .catch((e) => {
          console.log('error log:', e)
        })
    },
    readMag () {
      const para = {
        announcement_id: this.detailObj.id
      }
      api
        .axiosRequest(api.urlList.readMsg, para)
        .then((res) => {
          if (res.code === common.resCode.OK) {

          } else {
            utils.judgeBackMsg(res)
          }
        })
        .catch((e) => {
          console.log('error log:', e)
        })
    },
    onClickLeft () {
      this.$router.go(-1)
    }

  }
}
</script>
<style scoped lang="scss">
.content_box {
  .message_box {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding: 0.625rem 0.9375rem;
    background-color: #fff;
    color: #666;

    .create-time {
      display: flex;
      align-items: center;
      font-size: 1rem;
      color: #666;
    }
    .content-wrap {
      margin-top: 0.625rem;
      display: flex;
    }

    .content-title {
      white-space: nowrap;
      font-size: 1rem;
      color: #666;
    }

  }
}
</style>
